import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clickTrack(event) {
    const clickedElement = event.currentTarget
    const clickUrl = clickedElement.dataset.click
    
    if (clickUrl) {
      const adsList = Array.from(document.querySelectorAll('a[data-controller="adclick"]'))
      
      const url = new URL(clickUrl)
      url.searchParams.append('position', adsList.indexOf(clickedElement))
      url.searchParams.append('scroll', 0)

      fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        }
      }).catch(error => console.error('Error:', error))
    }
  }
}